import { Component, type ReactNode, type ErrorInfo } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
  info: ErrorInfo | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null, info: null };

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[sovereign-muse] unhandled error:', error);
    console.error('component stack:', info.componentStack);
    this.setState({ info });
  }

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            padding: '32px',
            fontFamily: 'JetBrains Mono, monospace',
            fontSize: '13px',
            color: '#c45a5a',
            background: '#0b0b0e',
            minHeight: '100vh',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          }}
        >
          <div style={{ color: '#c9b896', fontSize: '16px', marginBottom: '16px' }}>
            ◉ Sovereign MUSE — crash on mount
          </div>
          <div style={{ color: '#f0eee9', marginBottom: '8px' }}>
            {this.state.error.name}: {this.state.error.message}
          </div>
          <div style={{ color: '#8a877f', fontSize: '11px', marginTop: '16px' }}>
            Stack:
          </div>
          <div style={{ color: '#5e5c58', fontSize: '11px' }}>
            {this.state.error.stack}
          </div>
          {this.state.info?.componentStack && (
            <>
              <div style={{ color: '#8a877f', fontSize: '11px', marginTop: '16px' }}>
                Component stack:
              </div>
              <div style={{ color: '#5e5c58', fontSize: '11px' }}>
                {this.state.info.componentStack}
              </div>
            </>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}
